import { render } from "./ReportsContainer.vue?vue&type=template&id=2fc5a716&scoped=true"
import script from "./ReportsContainer.vue?vue&type=script&lang=js"
export * from "./ReportsContainer.vue?vue&type=script&lang=js"

import "./ReportsContainer.vue?vue&type=style&index=0&id=2fc5a716&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc5a716"]])

export default __exports__